module.exports = function() {
  return new Worker(__webpack_public_path__ + "c426d58594eef517d0c5.worker.js");
};